/** Shared price-field helpers for the admin forms */

/** Prices are kept as strings so an empty field stays distinct from a zero */
export interface PriceFields {
  us: string;
  eu: string;
  kzt: string;
}

export const EMPTY_PRICE: PriceFields = { us: '', eu: '', kzt: '' };

const to_field = (amount: number | undefined): string =>
  typeof amount === 'number' ? String(amount) : '';

/** Seeds the form from a stored price */
export const price_to_fields = (
  price?: { us: number; eu?: number; kzt?: number } | null
): PriceFields =>
  price
    ? { us: to_field(price.us), eu: to_field(price.eu), kzt: to_field(price.kzt) }
    : EMPTY_PRICE;

/**
 * Builds the save payload. USD alone is enough — the server converts whatever
 * is missing; a blank USD means the entity has no price at all.
 */
export const fields_to_price = (
  fields: PriceFields
): { us: number; eu?: number; kzt?: number } | null => {
  if (fields.us.trim() === '') {
    return null;
  }
  return {
    us: Number(fields.us),
    ...(fields.eu.trim() !== '' ? { eu: Number(fields.eu) } : {}),
    ...(fields.kzt.trim() !== '' ? { kzt: Number(fields.kzt) } : {}),
  };
};
